"use client";

import type {
  UtilityBarOffice,
  UtilityBarOfficeHours,
} from "~www/types/utility-bar";

import { cn } from "@homeinstead/ui";
import LocationDetails from "./LocationDetails";
import OfficeHours from "./OfficeHours";

interface UtilityBarProps {
  office?: UtilityBarOffice;
  officePageURL?: string;
  hours?: UtilityBarOfficeHours[];
  className?: string;
}

function UtilityBar({
  office,
  hours,
  className,
  officePageURL,
}: UtilityBarProps) {
  return (
    <div
      className={cn(
        "relative z-50 w-full bg-new-beginnings-tints-200 text-support-base md:text-sm",
        className,
      )}
    >
      <div className="mx-auto flex h-12 max-w-screen-hd items-center justify-between gap-1 xs:gap-1 px-4">
        <LocationDetails office={office} officePageURL={officePageURL} />
        <OfficeHours hours={hours} office={office} />
      </div>
    </div>
  );
}

export default UtilityBar;
